import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import jsDig from "utils/jsDig";
import OrgPickerModal from "organizations/OrgPickerModal"

export default function OrgPicker(props) {
  let orgPic = <img className="avatar-picker" style={{ marginRight: "10px" }} src={props.logo} />;
  let dpLogo = require("images/logos/dp-logo-white.png");
  dpLogo = <img className="avatar-picker" style={{ marginRight: "10px" }} src={`/datapulse${dpLogo}`} />;
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const isClickable = (props.organizations && (props.organizations.length > 1)) || props.god_or_admin
  let orgName = props.selected_org.name
  if (orgName.length > 20) {
    orgName = orgName.slice(0,20) + "..."
  }

  return (
    <Row className="text-left m-0 justify-content-center mb-2">
      {(props.organizations && props.organizations.length > 0) && (
        <OrgPickerModal show={show} setShow={setShow} selectedOrg={props.selected_org} organizations={props.organizations} />
      )}
      <Col xs={11}>
        <div className="dropdown show  org-picker-side ">
          <a
            className={` picker-link ${isClickable ? "hoverable" : ""}`}
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
          >
            <Row className="p-0 m-0" style={{ flexWrap: 'nowrap' }}>
              <Col className="pr-0">
                <span style={{whiteSpace:"nowrap"}} className=""> {props.logo ? orgPic : dpLogo} {orgName}</span>
              </Col>
              {isClickable ?
              <Col xs={1}  className="align-self-center pr-3">


                <span><i className="fa ml-0 fa-ellipsis-v"></i></span>

              </Col>
                : <></>
              }
            </Row>
          </a>
          {isClickable ?
            <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
              {props.organizations.length > 1 &&
                <p onClick={handleShow}  className="dropdown-item org-picker-side-item">
                Change Organization
              </p>
              }
              {
                props.god_or_admin &&

                <a className="dropdown-item org-picker-side-item" href={window.location.origin + "/datapulse/organization/" + jsDig(["selected_org", "id"], props)}>
                Organization Settings
              </a>
              }
            </div>
            : <></>
            }
        </div>
      </Col>
    </Row>
  );
}
